function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 10.2L12.1621 11.0028C10.1785 12.1929 8.89458 14.2704 8.71717 16.5768C8.70735 16.7045 8.6043 16.8051 8.47639 16.8118L6.81071 16.8997C5.6581 16.9605 4.69343 16.0357 4.70549 14.8816L4.77806 7.93758C4.78977 6.81702 5.71976 5.92476 6.83983 5.95943L13.0523 6.15176C15.0165 6.21256 15.7244 8.77323 14.0703 9.83423L13.5 10.2Z",
  fill: "#FFAF00",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 3C5.89543 3 5 3.89543 5 5V16C5 17.1046 5.89543 18 7 18H11C11.2761 18 11.5 17.7761 11.5 17.5C11.5 17.2239 11.2761 17 11 17H7C6.44772 17 6 16.5523 6 16V5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V8.5C18 8.77614 18.2239 9 18.5 9C18.7761 9 19 8.77614 19 8.5V5C19 3.89543 18.1046 3 17 3H7ZM21 9.5C21 9.22386 20.7761 9 20.5 9C20.2239 9 20 9.22386 20 9.5V10.5C20 10.7761 20.2239 11 20.5 11C20.7761 11 21 10.7761 21 10.5V9.5ZM3.5 9C3.77614 9 4 9.22386 4 9.5V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.5C3 9.22386 3.22386 9 3.5 9ZM8.5 5C8.22386 5 8 5.22386 8 5.5C8 5.77614 8.22386 6 8.5 6H15.5C15.7761 6 16 5.77614 16 5.5C16 5.22386 15.7761 5 15.5 5H8.5ZM7 19C7.27614 19 7.5 19.2239 7.5 19.5V19.9348C7.5 19.9708 7.5292 20 7.56522 20H8.93478C8.9708 20 9 19.9708 9 19.9348V19.5C9 19.2239 9.22386 19 9.5 19C9.77614 19 10 19.2239 10 19.5V19.9348C10 20.5231 9.52309 21 8.93478 21H7.56522C6.97691 21 6.5 20.5231 6.5 19.9348V19.5C6.5 19.2239 6.72386 19 7 19ZM8 14.5C8 14.2239 8.22386 14 8.5 14C8.77614 14 9 14.2239 9 14.5C9 14.7761 8.77614 15 8.5 15C8.22386 15 8 14.7761 8 14.5ZM8.5 13C7.67157 13 7 13.6716 7 14.5C7 15.3284 7.67157 16 8.5 16C9.32843 16 10 15.3284 10 14.5C10 13.6716 9.32843 13 8.5 13Z",
  fill: "#FFAF00"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 15.0357C20.5 18.0769 18.05 20.1538 17 20.5C15.95 20.1538 13.5 18.0769 13.5 15.0357C13.5 13.083 15.067 11.5 17 11.5C18.933 11.5 20.5 13.083 20.5 15.0357Z",
  stroke: "#FFAF00",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 15,
  r: 1,
  fill: "#FFAF00"
});
const SvgStops = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStops, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stops.091a41f0.svg";
export { ForwardRef as ReactComponent };